const mask = {
  m3: 2,
  hL: 4,
  L: 2,
  dL: 1,
  cL: 0,
  mL: 0,
  barrelUS: 3,
  barrelUK: 3,
  flozUK: 2,
  flozUS: 2,
  galUK: 3,
  galUS: 3,
  giUK: 3,
  giUS: 3,
  pintUK: 3,
  pintUS: 3,
  qtUK: 3,
  qtUS: 3,
  celsius: 2,
  fahrenheit: 2,
  TAV: 2,
  AbVol: 2,
  proofUS: 2,
  proofUK: 2,
  cm: 1,
  in: 2,
  ft: 2,
  // Mass units
  kg: 3,
  g: 0,
  mg: 0,
  lb: 3,
  oz: 3,
  // Density units - based on g/L = 2 decimals (0.01 g/L precision)
  'g/L': 2, // Base standard
  'mg/L': 0, // 0.01 g/L = 10 mg/L → 0 decimals
  'kg/m3': 2, // 1 kg/m³ = 1 g/L (equivalent)
  'kg/L': 5, // 0.01 g/L = 0.00001 kg/L → 5 decimals
  'g/mL': 5, // 0.01 g/L = 0.00001 g/mL → 5 decimals (same as kg/L)
  'g/cm3': 5, // g/cm³ = g/mL = kg/L → 5 decimals
  'lb/galUS': 4, // 0.01 g/L ≈ 0.00008 lb/galUS → 4 decimals
  'lb/galUK': 4, // 0.01 g/L ≈ 0.0001 lb/galUK → 4 decimals
};

module.exports = mask;
